// Derive the URL mount prefix at runtime so the SPA works at the root path "/"
// (local dev) AND under a reverse-proxy sub-path such as orbital-laser.com/land-ai/
// with NO build-time PUBLIC_URL and NO rebuild.
//
// The orbital-laser nginx reverse-proxies /land-ai/* -> lambda2:3001 (the CRA dev
// server serving a root-built app) and rewrites the served HTML's asset refs to add
// the /land-ai prefix, so the loaded bundle tag is e.g.
//   <script src="/land-ai/static/js/bundle.js">
// We recover the effective prefix from that rendered path. At a root deploy the
// prefix resolves to "". Falls back to PUBLIC_URL for genuine build-time prefixing.
export function getBasePath() {
  try {
    const scripts = document.querySelectorAll('script[src]');
    for (let i = 0; i < scripts.length; i += 1) {
      const raw = scripts[i].getAttribute('src');
      if (!raw) continue;
      const u = new URL(raw, window.location.href);
      const m = u.pathname.match(/^(.*)\/static\/js\/[^/]+\.js$/);
      if (m) return m[1]; // "" at root, "/land-ai" under a sub-path
    }
  } catch (e) {
    /* jsdom / SSR — fall through to env fallback */
  }
  const env = (typeof process !== 'undefined' && process.env && process.env.PUBLIC_URL) || '';
  return env.replace(/\/$/, '');
}
